import dayjs from 'dayjs';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CustomButton from '../../shared/CustomButton/CustomButton';
import CustomDatePicker from '../../shared/CustomDatePicker/CustomDatePicker';
import styles from './DateNavigator.module.scss';

interface DateNavigatorProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
}

export default function DateNavigator({ selectedDate, onDateChange }: DateNavigatorProps) {
  // Usa dayjs per aritmetica su stringhe YYYY-MM-DD evitando lo shift UTC+
  // che si otterrebbe con new Date(str).toISOString() su timezone UTC+.
  const handlePrevDay = () => {
    onDateChange(dayjs(selectedDate).subtract(1, 'day').format('YYYY-MM-DD'));
  };

  const handleNextDay = () => {
    onDateChange(dayjs(selectedDate).add(1, 'day').format('YYYY-MM-DD'));
  };

  const handleToday = () => {
    // dayjs() usa il clock locale → formato date-only corretto in qualsiasi TZ.
    onDateChange(dayjs().format('YYYY-MM-DD'));
  };

  // dayjs().format usa il fuso locale → nessun off-by-one UTC+.
  const today = dayjs().format('YYYY-MM-DD');
  const isToday = selectedDate === today;

  // CustomDatePicker vuole un Date. new Date('YYYY-MM-DD') è UTC-midnight;
  // react-datepicker lo mostra come giorno corretto perché legge solo la parte
  // data locale quando dateFormat non include l'ora.
  const dateValue = selectedDate ? new Date(selectedDate + 'T12:00:00') : null;

  return (
    <div className={styles.wrapper}>
      {!isToday && (
        <CustomButton color="secondary" textSmall onClick={handleToday}>
          Vai a oggi
        </CustomButton>
      )}

      <button
        onClick={handlePrevDay}
        className={styles.navBtn}
        title="Giorno precedente"
      >
        <ChevronLeft className={styles.navIcon} />
      </button>

      <CustomDatePicker
        date={dateValue}
        onChange={(date) => {
          // date è local-midnight restituito da react-datepicker.
          // dayjs(date).format() legge il locale → no off-by-one UTC+.
          if (date) onDateChange(dayjs(date).format('YYYY-MM-DD'));
        }}
        dateFormat="dd MMM yyyy"
        maxDate={new Date()}
        className={styles.datePicker}
      />

      <button
        onClick={handleNextDay}
        className={`${styles.navBtn} ${isToday ? styles.navBtnDisabled : ''}`}
        title="Giorno successivo"
        disabled={isToday}
      >
        <ChevronRight className={styles.navIcon} />
      </button>
    </div>
  );
}
